var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.9998C17.5227 21.9998 21.9999 17.5226 21.9999 11.9998C21.9999 6.47691 17.5227 1.99976 11.9999 1.99976C6.47703 1.99976 1.99988 6.47691 1.99988 11.9998C1.99988 17.5226 6.47703 21.9998 11.9999 21.9998Z",
    fill: "#8977A0",
    fillOpacity: 0.38,
    stroke: "#8977A0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.5L19.5 4.5",
    stroke: "#8977A0",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5L4.5 4.5",
    stroke: "#8977A0",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsent);
export default __webpack_public_path__ + "static/media/unsent.833148c19af540756cc7d9d82ea39f69.svg";
export { ForwardRef as ReactComponent };